<div class="reusable-form-components textarea-container">
 <ion-label class="label labelText">{{labelText}}</ion-label>
  <textarea *ngIf="!contentEditable"  rows="{{rows||7}}" [maxlength]="maxLength" [placeholder]="placeholder" [(ngModel)]="notes"></textarea>
  <div class="text-area" *ngIf="contentEditable"  contenteditable="true" [innerHTML]="notes | sanitizeHtml"></div>

  <div class="char-count">{{ notes?.length }} / {{ maxLength }}</div>
</div>

